import type { Region } from '../hooks/useRegion';

interface RegionSelectorProps {
  region: Region;
  onChange: (region: Region) => void;
}

const regions: { value: Region; label: string }[] = [
  { value: 'au', label: 'AU' },
  { value: 'us', label: 'US' },
  { value: 'intl', label: 'INTL' },
];

export function RegionSelector({ region, onChange }: RegionSelectorProps) {
  return (
    <div class="region-selector" role="group" aria-label="Select region">
      {regions.map((r) => (
        <button
          key={r.value}
          class={`region-selector__btn ${region === r.value ? 'region-selector__btn--active' : ''}`}
          onClick={() => onChange(r.value)}
          aria-pressed={region === r.value}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
